import api from '@/utils/api';

/**
 * Get current logged in user profile
 * @returns {Promise}
 */
const getProfileApi = () => api.get('user/profile');

export default getProfileApi;
